import _ from 'lodash';

export default {

	methods:{

		//Short cuts for loading bar
		addLoad(loadName){
			this.$store.commit('addLoad', loadName);
		},
		endLoad(loadName){
			this.$store.commit('endLoad', loadName);
		},
		isLoad(loadName){
			return this.$store.state.loaderList.some( el => el === loadName);
		},
		localRandomString() {
			function s4() {
				return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
			}
			return (s4()+s4()+"-"+s4()+"-"+s4()+"-"+s4()+"-"+s4()+s4()+s4());
		},

		snakeCase(string){
			return _.snakeCase(string);
		}
	}
}